import { mapState, mapActions } from 'vuex';
import contractsHistory from '@/components/contracts-history/contracts-history.vue';
import exportHistory from '@/components/export-history/export-history.vue';
import historyFilters from '@/components/account/history/trades/history-filters/history-filters.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import { isMarketSingle } from '@/utils/helpers';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  props: {
    showExport: Boolean,
  },
  components: {
    contractsHistory,
    exportHistory,
    historyFilters,
  },
  data() {
    return {
      activeFilter: null,
      marketId: undefined,
      recent: true,
      isOpen: false,
      loading: null,
    };
  },
  watch: {
    activeFilter(val) {
      if (val) {
        this.doLoading(val.marketId);
      }
    },
    $route: {
      handler: 'routeHandler',
      immediate: true,
    },
  },
  computed: {
    ...mapState('market', ['market']),
    ...mapState('profile', [
      'tradeHistory',
      'marketHistory',
      'tradedMarkets',
    ]),
    showMessage() {
      return !this.isLoading &&
        this.$route.params.marketId &&
        this.$route.params.marketId !== 'all' &&
        this.market.marketId &&
        !isMarketSingle(this.market);
    },
    filteredContracts() {
      if (this.activeFilter) {
        // to not show old data while loading new
        return (this.activeFilter.marketId !== this.marketHistory.marketId) ?
          [] : this.marketHistory.data;
      }
      // whole trade history
      return this.tradeHistory.data;
    },
    canLoadMore() {
      return this.activeFilter ? this.marketHistory.canLoadMore : this.tradeHistory.canLoadMore;
    },
    showMarketNames() {
      return this.activeFilter === null;
    },
    isExportAvailable() {
      return this.showExport;
        // this.tradeHistory &&
        // this.tradeHistory.data &&
        // this.tradeHistory.data.length > 0;
    },
  },
  methods: {
    ...mapActions('profile', ['getTradeHistory', 'getTradedMarkets']),
    ...mapActions('market', ['getMarket', 'clearMarket']),
    routeHandler(route) {
      const marketId = route.params.marketId;
      const isAll = marketId === 'all';
      const isEmpty = !marketId;
      this.loaderAdd(document.body);

      if (marketId && !isAll) {
        this.marketId = Number(marketId);
      } else if (isAll) {
        this.marketId = 'all';
      } else {
        this.marketId = undefined;
      }

      this.getTradedMarkets({ cache: true })
        .then((val) => {
          if (this.marketId) {
            const marketFilter = val.find(o => o.marketId === this.marketId);
            if (marketFilter) {
              this.activeFilter = { ...marketFilter };
            }
          }
        })
        .then(() => {
          if (marketId && !isAll) {
            this.clearMarket();
            return this.getMarket({ marketId: this.marketId });
          } else if (isAll) {
            this.clearMarket();
            return this.getTradeHistory();
          }
          return Promise.resolve({});
        })
        .then(() => {
          this.loaderRemove(document.body);
          this.isOpen = isAll;
          this.recent = isEmpty;
          if (isEmpty || isAll) {
            this.activeFilter = null;
          }
        });
    },
    loadHistory() {
      if (this.activeFilter) {
        if (this.loading !== this.activeFilter.marketId) {
          this.doLoading(this.activeFilter.marketId);
        }
      }
      if (this.tradeHistory.canLoadMore) {
        this.getTradeHistory();
      }
    },
    modalExport() {
      this.$emit('export', 'trades');
    },
    doLoading(marketId) {
      if (this.loading !== marketId) {
        this.loading = marketId;
        const contractId = (this.$route.query || {}).contractId;
        const payload = { marketId };
        if (contractId) {
          payload.contractId = contractId;
        }
        return this.getTradeHistory(payload).then(() => {
          this.loading = null;
        });
      }
      return Promise.resolve({});
    },
  },
  beforeDestroy() {
    this.clearMarket();
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/trades.js